// extracted by mini-css-extract-plugin
export default {"workOrderInfo":"WorkOrderInfo_workOrderInfo__SHCxW","description":"WorkOrderInfo_description__iyXex"};